"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThunderstormAbilityHandler = exports.ThunderstormActorAbilityFactory = exports.ThunderstormAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ThunderstormAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Thunderstorm;
        this.__typeName = "Thunderstorm";
    }
}
exports.ThunderstormAbilityArgs = ThunderstormAbilityArgs;
let ThunderstormActorAbilityFactory = class ThunderstormActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Thunderstorm", "AllEnemies", 2);
    }
};
ThunderstormActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Thunderstorm")
], ThunderstormActorAbilityFactory);
exports.ThunderstormActorAbilityFactory = ThunderstormActorAbilityFactory;
let ThunderstormAbilityHandler = class ThunderstormAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const { applyCameraVfx, resetCameraVfx } = core_1.CameraVfxStepArgs.mkSequencesFor(core_1.CameraVfxStepArgs.Alpha(.5));
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            attackType: "magic",
            abilityKey: ability.args.__typeName,
            targets: enemies.map((enemy, i) => ({
                jitter: (0, Random_1.random)(50, 200),
                targetId: enemy,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 50),
                    AbilityDamage_1.AbilityDamage.Focus("Sonic", 50),
                ],
            })),
            sequence: sequence.pushSequence("parallel")
                .push(applyCameraVfx.mk())
                .pushSequence("sequential"),
            onHit(sequence, { targetId }) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "LightningStrikeBlue"));
            },
            onMiss(sequence, { targetId }) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "random"), "LightningStrikeBlue"));
            },
        });
        sequence.push(resetCameraVfx.mk());
    }
};
ThunderstormAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Thunderstorm)
], ThunderstormAbilityHandler);
exports.ThunderstormAbilityHandler = ThunderstormAbilityHandler;
